<template>
    <v-row>
        <div class="col-md-12 home-box">
            <Breadcrumbs :title="'Payment Vouchers'"></Breadcrumbs>
            <VoucherList></VoucherList>

        </div>
    </v-row>
    
</template>



<script>
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import VoucherList from "@/components/paymentVouchers/PaymentVoucherList.vue";
export default {
    name: 'grn',
    components:{
        Breadcrumbs,
        VoucherList

    }
}
</script>